import { render, staticRenderFns } from "./card-info.vue?vue&type=template&id=695626bc&scoped=true&"
import script from "./card-info.vue?vue&type=script&lang=js&"
export * from "./card-info.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "695626bc",
  null
  
)

export default component.exports